<template>
  <div v-if="filteredFaqs && filteredFaqs.length" class="faq-category">
    <div
      class="faq-category__header"
      :style="`background: ${faqCategory.background}`"
    >
      <h2 class="faq-category__title">{{ faqCategory.name }}</h2>
      <div
        class="faq-category__description"
        v-html="faqCategory.short_description"
      ></div>
    </div>
    <div class="faq-category__content-wrapper">
      <div
        v-if="faqCategory.content && faqCategory.content.length"
        class="faq-category__content"
      >
        <div
          class="faq-category__content__description"
          v-html="faqCategory.description_html"
        ></div>
        <FaqItem
          v-for="faq in filteredFaqs"
          :key="faq.title"
          :faq="faq"
          :searchQuery="searchQuery"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FaqItem from '@/components/faqs/FaqItem.vue'

export default {
  name: 'FaqCategory',
  components: {
    FaqItem,
  },
  props: {
    faqCategory: {
      type: Object,
      required: true,
    },
    searchQuery: {
      type: String,
      required: true,
    },
  },
  computed: {
    filteredFaqs() {
      const searchQuery = this.searchQuery
      if (!this.searchQuery) {
        return this.faqCategory.content
      } else {
        return this.faqCategory.content.filter(faq => {
          return (
            faq.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            faq.text_html?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            faq?.content?.filter(innerFaq => {
              return (
                innerFaq.title
                  ?.toLowerCase()
                  .includes(searchQuery.toLowerCase()) ||
                innerFaq.text_html
                  ?.toLowerCase()
                  .includes(searchQuery.toLowerCase())
              )
            })
          )
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.faq-category {
  display: flex;
  width: 100%;
  align-items: flex-start;
  border-radius: 20px;
  flex-wrap: wrap;
  background: var(
    --Glass-Mid-gray,
    linear-gradient(
      105deg,
      rgba(62, 63, 73, 0.7) -13.91%,
      rgba(62, 63, 73, 0) 100.48%
    )
  );
  @include desktop {
    flex-wrap: nowrap;
  }
  &__header {
    width: 100%;
    display: flex;
    padding: 10px 15px;
    flex-direction: column;
    align-items: flex-start;
    flex-shrink: 0;
    align-self: stretch;
    border-radius: 20px 20px 0px 0px;
    @include tablet {
      width: 330px;
      padding: 30px;
      border-radius: 20px 0px 0px 20px;
      gap: 5px;
    }
  }
  &__title {
    color: var(--white);
    font-size: rem(18px);
    font-style: normal;
    font-weight: 700;
    line-height: rem(24px); /* 133.333% */
    margin: 0 0 5px 0;
    @include mobile {
      font-size: rem(24px);
      line-height: rem(66px);
      line-height: rem(32px); /* 102.5% */
    }
    @include tablet {
      font-size: rem(40px);
      line-height: rem(41px); /* 102.5% */
    }
  }
  &__description {
    color: var(--white);
    font-size: rem(16px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(24px); /* 150% */
  }
  &__content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 0 0;
  }
  &__content {
    display: flex;
    padding: 15px;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
    align-self: stretch;
    @include tablet {
      padding: 30px;
    }
    &__description {
      color: var(--white);
      font-size: rem(14px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(20px); /* 142.857% */
    }
  }
}
</style>
